import React from "react";
import styles from "./style.module.css";

const introDescription = ` One day, mutant frogs appear all over the world\nwho seem to have a goal to fight against\nall things that pollute the Earth.`;

function Intro() {
  return (
    <div className={styles.backgroundWrapper}>
      <div className={styles.ggnzWrapper}>
        <section className={styles.sectionWrapper}>
          <span className={styles.introHeader}>The Mutant Frogs</span>
          <div className={styles.introTitle}>GAEGUNEEZ</div>

          <p className={styles.introDescription}>{introDescription}</p>
          <div
            onClick={() => window.open("https://mint.ggnz.io/")}
            className={styles.buttonWrapper}
          >
            <span>MINT</span>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Intro;
